import { number, object } from "yup"
import { ID2 } from "../yup.common"
const gradePriceModel = object({
  grade: ID2("Grade").label("Grade ID"),
  price: number()
    .min(0)
    .required("Grade Price is required!")
    .label("Grade Price"),
  priceUnit: ID2("Price Unit")
    .required("Price Unit is required!")
    .label("Price Unit"),
  priceLimit: number()
    .label("Price Limit")
    .positive("Price Limit should be more than 0")
    .nullable(),
})

export default gradePriceModel
